import React, { useEffect, useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [horaires, setHoraires] = useState({});
  const [infos, setInfos] = useState({});

  useEffect(() => {
    fetch(`/assets/json/horaires.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => setHoraires(data))
      .catch(error => console.error('Erreur lors de la récupération des horaires:', error));

    fetch(`/assets/json/infos-generale.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => setInfos(data))
      .catch(error => console.error('Erreur lors de la récupération des informations générales:', error));
  }, []);

  const isFerme = (heures) =>
    typeof heures === 'string' && heures.toLowerCase().includes('ferm');

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Colonne 1 — Logo + Contact */}
        <div className="footer-column footer-col-brand">
          <div className="footer-logo">
            <img src="/assets/images/logo.jpg" alt={infos.nomSite} />
          </div>
          <p className="footer-brand-name">{infos.nomSite}</p>
          <ul className="footer-contact-list">
            <li>
              <span className="footer-contact-icon">📍</span>
              <span>{infos.adresse}</span>
            </li>
            <li>
              <span className="footer-contact-icon">📞</span>
              <a href={`tel:${infos.telephone}`}>{infos.telephone}</a>
            </li>
            <li>
              <span className="footer-contact-icon">✉️</span>
              <a href={`mailto:${infos.email}`}>{infos.email}</a>
            </li>
          </ul>
        </div>

        {/* Colonne 2 — Horaires */}
        <div className="footer-column">
          <h3 className="footer-col-title">Horaires d'ouverture</h3>
          <table className="footer-horaires-table">
            <tbody>
              {Object.entries(horaires).map(([jour, heures]) => (
                <tr key={jour} className={isFerme(heures) ? 'horaire-ferme' : ''}>
                  <td className="horaire-jour">{jour}</td>
                  <td className="horaire-heures">{heures}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Colonne 3 — Carte PDF */}
        <div className="footer-column">
          <h3 className="footer-col-title">Notre Carte</h3>
          <p className="footer-carte-desc">
            Consultez l'ensemble de nos plats et menus disponibles à emporter.
          </p>
          <a
            href="/assets/carte.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            className="footer-pdf-btn"
          >
            <span className="footer-pdf-icon">📄</span>
            <span>Télécharger la carte PDF</span>
          </a>
        </div>

        {/* Colonne 4 — Bloc RestoGo premium */}
        <div className="footer-column footer-col-restogo">
          <div className="restogo-card">
            <span className="restogo-badge">Powered by</span>
            <p className="restogo-name">RestoGo</p>
            <p className="restogo-desc">
              La solution clé-en-main pour créer votre site restaurant avec commande en ligne, gestion des menus et tableau de bord intégré.
            </p>
            <a
              href="https://www.resto-go.com"
              target="_blank"
              rel="noopener noreferrer"
              className="restogo-cta"
            >
              Créer mon site restaurant →
            </a>
          </div>
        </div>

      </div>

      {/* Bas de page */}
      <div className="footer-bottom">
        <p className="footer-copyright-text">
          &copy; {infos.copyright?.annee} {infos.nomSite}. Tous droits réservés.
          Développé par{' '}
          <a href={infos.copyright?.['lien-site']} target="_blank" rel="noopener noreferrer">
            {infos.copyright?.['lien-label']}
          </a>.
        </p>
        <a href="/dashboard" className="footer-connexion-link">Connexion</a>
      </div>
    </footer>
  );
};

export default Footer;
